import { CookieHelper } from 'Utils/cookieHelper'
import { COOKIE_KEYS, PARAMS_COOKIE_KEYS } from 'Consts/cookies.enum'

export const useLoginStatus = () => {
  const { getCookie, getLogicCookieData } = CookieHelper()
  const notLoggedIn =
    !getCookie(COOKIE_KEYS.TOKEN) ||
    !getLogicCookieData(PARAMS_COOKIE_KEYS.ACCOUNT_ID) ||
    !getLogicCookieData(PARAMS_COOKIE_KEYS.USER_ID)

  return { isLoggedIn: !notLoggedIn }
}
